import styled from 'styled-components'

import { color, spacing, typography } from '../../themes'
import type { Size } from './types'

interface LabelProps {
  disabled?: boolean
}

export const Label = styled.label<LabelProps>`
  cursor: ${({ disabled }) => (!disabled ? 'pointer' : 'default')};
  user-select: none;
  display: flex;
  align-items: flex-start;
  width: 100%;
`

interface LabelInnerProps {
  size: Size
  disabled?: boolean
}

export const LabelInner = styled.span<LabelInnerProps>`
  display: block;
  ${({ size }) => typography(size === 'large' ? 'body1' : 'body2')}
  color: ${({ disabled }) => (!disabled ? color('gray.01') : color('gray.03'))};
  margin-left: ${spacing(2)};
  line-height: ${({ size }) => (size === 'large' ? '24px' : '20px')};
`
